import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { CommonService } from "../../_services/common.service";
import { FlashMessagesService } from "angular2-flash-messages";
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormArray,
  FormControl
} from "@angular/forms";
export interface DialogData {
  category_id: string,
  name: string
}

@Component({
  selector: 'app-add-category',
  templateUrl: './add-category.component.html',
  styleUrls: ['./add-category.component.css']
})
export class AddCategoryComponent implements OnInit {
  addCategoryForm: FormGroup;
  Options = {};
  public errormsg:string;
  public title:string;
  private result = '';
  public activeClass: string;
  constructor(private formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<AddCategoryComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private CommonService: CommonService,
    private _flashMessagesService: FlashMessagesService) { }

  ngOnInit() {
    this.addCategoryForm = this.formBuilder.group({
      categoryName: [null, Validators.required]
    });
    this.title="Add Category";
    if (this.data.name) {
      this.title="Update Category"
      this.activeClass = 'active';
      this.addCategoryForm.setValue({
        'categoryName': this.data.name
      });
    }
  }

  onNoClick(): void {
    this.dialogRef.close(this.result);
  }

  isFieldValid(field: string) {
    return (
      !this.addCategoryForm.get(field).valid &&
      this.addCategoryForm.get(field).touched
    );
  }

  SaveCategories = function (postData) {
    this.errormsg="";
    this.Options = {   
      id: localStorage.getItem("userID"),   
      name: postData.categoryName
    };
    let apiName = 'category/create';    
    if (this.data.category_id) {
      this.Options.id = this.data.category_id;
      this.Options.shop_id=localStorage.getItem("userID");
      apiName = 'category/edit'
    }
   
    this.CommonService.apiService(
      "POST",
      apiName,
      this.Options
    ).subscribe(
      (response: any) => {
        if (response.status === true) {
          // this._flashMessagesService.show(response.message, {
          //   cssClass: "alert-success",
          //   timeout: 1000
          // });            
          this.result = "success";
          this.dialogRef.close(this.result);
        }
        window.scrollTo(0, 0);
      },
      err => {
        // this._flashMessagesService.show(err.error.message, {
        //   cssClass: "alert-danger",
        //   timeout: 5000
        // });
        this.errormsg=err.error.message;       
        
      }
    );
  }

}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-products/add-category/add-category.component.ts